class GiftWithPurchase {
    constructor(product, type) {
      this.product = product;
      this.type = type
    }
  
    addGiftToCart() {
      console.log("GWP START");

      const ajaxCart = document.querySelector('ajax-cart');

      let config = fetchConfig('javascript');

      config.body = JSON.stringify(
        {
          "id": this.product,
          "quantity": 1,
          "properties": {
            '_is_gift_with_purchase': true,
            '_gwp_type': this.type
          },
          "sections": ajaxCart.getSectionsToRender().map((section) => section.id),
          "sections_url": window.location.pathname
        }
      );



      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        console.log("GWP ADDED");
        ajaxCart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
    }
  }
  